import { NamedError } from '../../utils/Errors';

export class AudioBackupError extends NamedError<AudioBackupErrors> {}

export enum AudioBackupErrors {
    UnsupportedBrowser = 'UnsupportedBrowser'
}